import { useQuery } from 'apollo-3/';

import { getMyExternalProfileInfo } from 'GraphQL/query/MyProfile.query';

const useMyExternalProfile = (apolloProps) => {
  const queryResult = useQuery(getMyExternalProfileInfo, apolloProps);
  return queryResult;
};

export default useMyExternalProfile;
